var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Nx-main-wrapper Nx-main-wrapper__containing-side-tips" },
    [
      _c("div", { staticClass: "Nx-main Nx-main__next-to-side-tips" }, [
        _c("div", { staticClass: "Nx-main__content" }, [_c("router-view")], 1),
      ]),
      _vm.hasTips
        ? _c(
            "div",
            { staticClass: "Nx-tips" },
            [_c("router-view", { attrs: { name: "tips" } })],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }